<template>
	<div class="mainView">
		<headerView class="header" currentMenu='paper'></headerView>
		<div class="header-bg-div"></div>
		<div class="title">{{ libraryTitle }}</div>
		<menuView></menuView>
		<div class="content">
			<leftCategory ref="leftCategory" v-show="false"></leftCategory>
			<contentView ref="contentView"></contentView>
		</div>
	</div>
</template>

<script>
// import pdf from 'vue-pdf'

import headerView from '@/components/main/headerView.vue'
import menuView from '../../components/paper/menuView.vue'
import leftCategory from '../../components/paper/leftCategory.vue'
import contentView from '../../components/paper/contentView.vue'

// import Compressor from 'compressorjs'

export default {
	name: 'appCommonPdf',
	props: {
		pdfUrl: {
		type: String,
			default: ''
		}
	},
	components: {
		// pdf
		headerView,
		menuView,
		leftCategory,
		contentView
	},
	data () {
		return {
			libraryTitle: this.global.getLibraryInfos().libraryTitle
		}
	},
	mounted () {
		// console.log(this.myPdf);
		// this.getPdfList();
		console.log($('#imgDiv'));
	},
	methods: {
		changeBookSelect (item) {
			this.$refs.contentView.changeBookSelect(item);
			this.$refs.leftCategory.changeBookSelect(item);
		}
	}
}
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.mainView {
	width: 100%;
	height: 100%;

	.header {
		width: 100%;
		height: 80 * @uh;
		z-index: 10;
		background: rgba(248, 248, 248, 0.7);
		position: relative;
		color: #8d5e1a;
	}

	.header-bg-div {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 1910 * @uw;
		height: 380 * @uh;
		background-image: url('~@/assets/images/main/header.jpg');
    	background-size: 100% 130%;
		z-index: 0;
	}

	.title {
		width: 520 * @uw;
		height: 40 * @uh;
		font-size: 40 * @uw;
		margin-left: 700 * @uw;
		position: relative;
		margin-top: 80 * @uh;
		color: #430a00;
	}

	.book-chart-div {
		width: 1200 * @uw;
		height: 482 * @uh;
		margin-top: 60 * @uh;
		margin-left: 360 * @uw;
		box-shadow: 0px 0px 10px 5px #e0e0e0;
	}

	.content {
		width: 1200 * @uw;
		height: auto;
		display: flex;
		justify-content: space-between;
		margin-left: 360 * @uw;
		margin-top: 30 * @uh;
	}
}
</style>
